import React, { useEffect, useRef } from "react";
import {Tabs,Tab,AppBar} from "@material-ui/core";
import Dashboardtable from './components/Dashboardtable';
import Dashboardtable_demo from './components/Dashboardtable_demo';
import NightParking from './components/NightParking';
import TopParkingLoc from './components/TopParkingLoc';
import Cars24NRT from "./components/Cars24NRT";
import BatteryDisconnectionReport from './components/BatteryDisconnectionReport';
import Today_inst from './components/Today_inst'
import Order_status from './components/order_status'
import CollectionTeam from "./components/CollectionTeam";
import MapPage from './Map';
import matchpointlogo from './assets/images/matchpointlogo.png';
import logout from './assets/images/logout.png';
import orange from './assets/images/orange.png';
import { Link , Redirect } from 'react-router-dom';
import Api_integration from "./components/Api_integration";
import ApiUrlCall from './components/Api/apiurl';


const Home = props => {
    const { match, history } = props;
    const { params } = match;
    const { page } = params;

    const tabNameToIndex = {
      0: "Install",
      1: "Dashboardtable",
      2: "Parking",
      3: "BatteryDisconnectionReport",
      4: "OrderStatus",
      5 : "TopParkingLoc",
      6: "Cars24NRT",
      7: "CollectionTeam",
      8: "Api_integration"
    };

    const indexToTabName = {
        Install :0,
        Dashboardtable: 1,
        Parking : 2,
        BatteryDisconnectionReport : 3,
        OrderStatus : 4,
        TopParkingLoc : 5,
        Cars24NRT : 6 ,
        CollectionTeam : 7,
        // Api_integration : 8
    };

    // Screen name mapping for tracking
    const tabToScreenName = {
      0: "InstallCases",
      1: "DelinquentCases",
      2: "NightParking",
      3: "BatteryDisconnect",
      4: "OrderStatus",
      5: "TopParkingLoc",
      6: "NRTReport",
      7: "CollectionTeam",
      8: "ApiIntegration"
    };

    const [selectedTab, setSelectedTab] = React.useState(indexToTabName[page]);
    const prevScreenRef = useRef(null);
    const hasEnteredRef = useRef(false);

    // Track initial screen enter on mount
    useEffect(() => {
      const initialScreen = tabToScreenName[indexToTabName[page]] || "InstallCases";
      prevScreenRef.current = initialScreen;
      ApiUrlCall.screenEnter(initialScreen)
        .then(() => { hasEnteredRef.current = true; })
        .catch(err => console.log('Screen enter error:', err));

      // Cleanup: exit screen on unmount (logout/navigate away)
      return () => {
        if (prevScreenRef.current && hasEnteredRef.current) {
          ApiUrlCall.screenExit(prevScreenRef.current)
            .catch(err => console.log('Screen exit error:', err));
        }
      };
    }, []);

    // Track screen changes on tab switch
    useEffect(() => {
      const currentScreen = tabToScreenName[selectedTab] || "InstallCases";
      if (hasEnteredRef.current && prevScreenRef.current && prevScreenRef.current !== currentScreen) {
        // Exit previous screen
        ApiUrlCall.screenExit(prevScreenRef.current)
          .catch(err => console.log('Screen exit error:', err));
        // Enter new screen
        ApiUrlCall.screenEnter(currentScreen)
          .catch(err => console.log('Screen enter error:', err));
      }
      prevScreenRef.current = currentScreen;
    }, [selectedTab]);

    const handleChange = (event, newValue) => {
      history.push(`/home/${tabNameToIndex[newValue]}`);
      setSelectedTab(newValue);
    };
  
    return (
       
<>
        <AppBar position="static">
          <Tabs value={selectedTab} onChange={handleChange}>
            <Tab label="Install Cases" />
            <Tab label="Delinquent cases" />
            <Tab label="Parking" />
            <Tab label="Battery Disconnect" />
            <Tab label="Order Status" />
            <Tab label="Top Parking Loc" />
            <Tab label="NRT Report" />
            <Tab label="Collection Team"/>
            {/* <Tab label="Api_integration"/> */}

     
          </Tabs>
        </AppBar>
        {selectedTab === 0 && < Today_inst/>}
        {selectedTab === 1 && <Dashboardtable_demo />}
        {selectedTab === 2 && <NightParking />}
        {selectedTab === 3 && <BatteryDisconnectionReport />}
        {selectedTab === 4 && <Order_status />}
        {selectedTab === 5 && <TopParkingLoc />}
        {selectedTab === 6 && <Cars24NRT />}
        {selectedTab === 7 && <CollectionTeam />}
        {/* {selectedTab === 8 && <Api_integration />} */}


 </>     

    );
  };
  export default Home;
